<template>
    <div class="page-case">
        <div class="section section-case-recommend">
            <div class="container">
                <div class="section section-case">
                    <!--<img src="../../assets/images/home/markorhome.svg"-->
                         <!--alt="markorhome"-->
                         <!--class="abs bg-img" style="width: 100%">-->
                    <div class="container">
                       <app-title style="margin-bottom: 15px">软装灵感</app-title>
                        <div class="img-box">
                            <img src="../../assets/images/case/bg.jpg" alt="" style="width: 100%;">
                        </div>
                    </div>
                </div>
                <!--<app-title>软装灵感</app-title>-->
                <!--<app-swiper class="swiper-case" :swiperOpts="caseSwiperOpts" ref="cases">-->
                    <!--<div slot="swiper-content" class="swiper-slide case-item" v-for="item in recommendCases"-->
                         <!--:key="item.id">-->
                        <!--<div class="inner" @click="selectedCaseId=item.id;$refs.caseDetail.visible=true">-->
                            <!--<div class="img"-->
                                 <!--:key="item.imgUrl+ '?x-oss-process=image/resize,m_fill,h_600,w_600,limit_0'"-->
                                 <!--v-lazy:background-image="item.imgUrl+ '?x-oss-process=image/resize,m_fill,h_600,w_600,limit_0'">-->
                                <!--<div class="label"></div>-->
                            <!--</div>-->
                            <!--<div class="info">-->
                                <!--<div class="title ellipsis">{{item.title}}</div>-->
                                <!--<div class="subtitle ellipsis">{{item.subTitle}}</div>-->
                                <!--<div class="rect"></div>-->
                                <!--<div class="tag-list">-->
                                    <!--<span class="tag-item" v-for="(tag,index) in item.tagList"-->
                                          <!--:key="index">{{tag}}</span>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</app-swiper>-->
            </div>
        </div>
        <div class="section section-case-list">
            <div class="container">
                <app-title>所有灵感</app-title>
                <div class="filter-box" style="margin: 30px auto">
                    <filter-select label="排序" :options="sortList" :change="sortChange"
                                   ref="sortSelect"></filter-select>
                    <search-input ref="searchInput" :searchFn="searchFn" style="float: right" placeholder="城市\户型\面积\风格"></search-input>

                </div>
                <ul class="case-list">
                    <li v-for="(item,index) in caseList" :key="index" class="case-item">
                        <div class="inner" @click="selectedCaseId=item.id;$refs.caseDetail.visible=true">
                            <div class="img"
                                 :key="item.imgUrl+ '?x-oss-process=image/resize,m_fill,h_600,w_600,limit_0'"
                                 v-lazy:background-image="item.imgUrl+ '?x-oss-process=image/resize,m_fill,h_600,w_600,limit_0'">
                                <div class="label"></div>
                            </div>
                            <div class="info">
                                <div class="title ellipsis">{{item.title}}</div>
                                <div class="subtitle ellipsis">{{item.subTitle}}</div>
                                <div class="tag-list">
                                    <span class="tag-item" v-for="(tag,index) in item.tagList"
                                          :key="index">{{tag}}</span>
                                </div>
                                <div class="other">
                                    <font-awesome-icon icon="eye"/>
                                    <span>{{item.hits}}</span>
                                    <font-awesome-icon icon="heart"/>
                                    <span>{{item.love}}</span>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <div style="text-align: center;margin: 20px auto;" v-if="page.index < page.total">
                    <app-button @click.native="getMore" size="md" color="gray-solid">加载更多</app-button>
                </div>
            </div>
        </div>
        <case-detail :id="selectedCaseId" ref="caseDetail">
        </case-detail>
    </div>
</template>

<script>
    import caseDetail from '../Case/Detail.vue'
    import SearchInput from '../../components/form/SearchInput'
    import FilterSelect from '../../components/filter/Select'
    // import swiper from '../../components/swiper/Swiper.vue'

    export default {
        metaInfo(){
            return {
                title:`软装灵感-Rehome官网-美克美家`,
                meta:[{
                    name: 'description',
                    content: ``,
                },{
                    name: 'keywords',
                    content: ``
                }]
            }
        },
        data() {
            return {
                selectedCaseId: null,
                caseDialogVisible: false,
                recommendCases: [],
                caseList: [],
                caseSwiperOpts: {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                },
                pageNo: 1,
                pageSize: 24,
                sortList: [{
                    id: 'releaseTimeDesc',
                    name: '从新到旧'
                }, {
                    id: 'releaseTimeAsc',
                    name: '从旧到新'
                }],
                searchValue: null,
                orderType: 'releaseTimeDesc',
                page: {
                    index: 1,
                    total: 1
                },
                caseIdMap: {},
                changeCase: null
            }
        },
        components: {
            SearchInput,
            'case-detail': caseDetail,
            'filter-select': FilterSelect
        },
        watch: {
            changeCase(data) {
                this.caseList[this.caseIdMap[data.id]].love = data.love
            }
        },
        methods: {
            sortChange(id) {
                this.pageNo = 1;
                this.orderType = id;
                this.getList();
            },
            searchFn() {
                this.pageNo = 1;
                this.orderType = 'releaseTimeDesc';
                this.searchValue = this.$refs.searchInput.inputValue;
                this.getList();
            },
            getMore() {
                this.pageNo++;
                this.$api.getCaseList({
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    orderType: this.orderType,
                    condition: this.searchValue || null
                }).then((res) => {
                    let map = {};
                    this.caseList = this.caseList.concat(res.rows);
                    this.page = res.page;
                    this.caseList.forEach((item, index) => {
                        map[item.id] = index
                    });
                    this.caseIdMap = map;
                });
            },
            getList() {
                this.$api.getCaseList({
                    pageSize: this.pageSize,
                    orderType: this.orderType,
                    condition: this.searchValue || null
                }).then((res) => {
                    let map = {};

                    this.caseList = res.rows;
                    this.page = res.page;
                    this.caseList.forEach((item, index) => {
                        map[item.id] = index
                    });
                    this.caseIdMap = map;
                });
            }
        },
        created() {
            this.$nextTick(() => {
                this.$refs.sortSelect.value = 'releaseTimeDesc'
            });
            // this.$api.getCasePageData().then((res) => {
            //     this.recommendCases = res.bannerList;
            //     this.$nextTick().then(() => {
            //         this.$refs.cases.initSwiper();
            //     });
            // });
            this.getList()

        }

    }
</script>

<style lang="scss" type="text/scss" scoped>
    @import "../../style/case-list";

    .page-case {
        padding-top: 60px;
    }

    .section-case-recommend {
        margin-bottom: 60px;
        .section-title {
            font-size: 24px;
            @include SourceHanSerifSC-bold;
            color: $title-color;
            line-height: 35px;
        }
        .oval {
            margin-bottom: 10px;
        }
    }

    .label {
        width: 57px;
        height: 61px;
        position: absolute;
        left:30px;
        top:0px;
        background: url('../../assets/images/label.png');
    }

    .section-case-list {
        .case-list {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            &:after {
                content: "";
                width: 630px;
            }
            .case-item {
                display: inline-block;
                width: 310px;
                margin-bottom: 50px;
                border-radius: 3px;
                box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
                &:hover {
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
                }
                a {
                    display: block;
                }
                .img {
                    height: 240px;
                    background-position: center;
                    background-size: cover;
                }
                .info {
                    padding: 10px;
                    .title {
                        font-size: 13px;
                        font-family: 'PingFangSC-Semibold';
                        font-weight: 600;
                        color: $title-color;
                        line-height: 18px;
                    }
                    .subtitle {
                        font-size: 11px;
                        font-family: 'PingFangSC-Light';
                        font-weight: 300;
                        color: #B8B8B8;
                        line-height: 16px;
                        margin-bottom: 11px;
                    }
                    .tag-list {
                        padding-bottom: 10px;
                        margin-bottom: 10px;
                        border-bottom: 1px solid #F5F5F5;
                        .tag-item {
                            font-size: 10px;
                            font-family: 'PingFangSC-Regular';
                            font-weight: 400;
                            color: #757575;
                            line-height: 14px;
                            padding: 3px 6px;
                            background-color: #F5F5F5;
                            margin-right: 5px;
                        }
                    }
                    .other {
                        line-height: 1;
                        span {
                            font-size: 10px;
                            font-family: 'PingFangSC-Light';
                            font-weight: 300;
                            color: #B8B8B8;
                            line-height: 14px;
                            margin: 0 8px 0 6px;
                        }
                        svg {
                            font-size: 12px;
                        }
                    }
                }
            }
        }
    }
    .section {
        .title-box {
            position: relative;
            margin-bottom: 16px;

            .t-1 {
                font-size: 24px;
                font-family: "BauerBodoniStd-Roman";
                font-weight: normal;
                color: #9b9b9b;
                line-height: 29px;
            }

            .t-2 {
                font-size: 50px;
                @include SourceHanSerifSC-bold;
                font-weight: bold;
                color: $title-color;
                line-height: 77px;

                &.en {
                    font-family: "BauerBodoniStd-Bold";
                }
            }

            .t-3 {
                font-size: 24px;
                color: $title-color;
                line-height: 35px;
                font-weight: bold;
            }

            .oval {
                margin-bottom: 10px;
                display: block;
                float: none;
            }

            .more {
                right: 0;
                top: 0;
            }

            &.center {
                text-align: center;

                .oval {
                    margin: 0 auto 10px;
                }
            }
        }
    }
    .section-case {

        .img-box {
            position: relative;

            .text-box {
                position: absolute;
                left: 130px;
                top: 90px;

                .en-title {
                    width: 157px;
                    height: 24px;
                    @include SourceHanSerifSC-bold;
                    background: #1F1F1F;
                    border-radius: 3px;
                    color: #fff;
                    font-size: 13px;
                    line-height: 24px;
                    text-align: center;
                    margin-bottom: 20px;
                }

                .title {
                    font-size: 42px;
                    font-family: 'STSongti-TC-Bold', 'SimSun';
                    color: rgba(55, 55, 55, 1);
                    line-height: 45px;
                    margin-bottom: 10px;
                }

                .desc {
                    font-size: 15px;
                    font-family: STSongti-TC-Bold;
                    font-weight: bold;
                    color: rgba(55, 55, 55, 1);
                    line-height: 45px;
                    letter-spacing: 6px;
                    margin-bottom: 20px;
                }
            }
        }
    }


</style>
